var _g, _g2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calendar",
    fill: "none",
    className: "default"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    fillRule: "evenodd",
    d: "M23 8.02H1v-4.5c0-.28.22-.5.5-.5H4V4.5c0 .28.22.5.5.5s.5-.22.5-.5V3.02h14V4.5c0 .28.22.5.5.5s.5-.22.5-.5V3.02h2.5c.28 0 .5.22.5.5v4.5zm0 14.5c0 .28-.22.5-.5.5h-21c-.28 0-.5-.22-.5-.5V9.02h22v13.5zm-3-20.5V.5c0-.27-.22-.5-.5-.5s-.5.23-.5.5v1.52H5V.5c0-.27-.22-.5-.5-.5S4 .23 4 .5v1.52H1.5c-.83 0-1.5.67-1.5 1.5v19c0 .83.67 1.5 1.5 1.5h21c.83 0 1.5-.67 1.5-1.5v-19c0-.83-.67-1.5-1.5-1.5H20z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "ActiveCalendar",
    fill: "none",
    className: "alt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    fillRule: "evenodd",
    d: "M23 8.02H1v-4.5c0-.28.22-.5.5-.5H4V4.5c0 .28.22.5.5.5s.5-.22.5-.5V3.02h14V4.5c0 .28.22.5.5.5s.5-.22.5-.5V3.02h2.5c.28 0 .5.22.5.5v4.5zm-.5-6H20V.5c0-.27-.22-.5-.5-.5s-.5.23-.5.5v1.52H5V.5c0-.27-.22-.5-.5-.5S4 .23 4 .5v1.52H1.5c-.83 0-1.5.67-1.5 1.5v19c0 .83.67 1.5 1.5 1.5h21c.83 0 1.5-.67 1.5-1.5v-19c0-.83-.67-1.5-1.5-1.5z"
  }))));
}

SvgCalendar.displayName = 'Calendar';
export default SvgCalendar;